import { lazy } from 'react'
import { Outlet, Route } from 'react-router-dom'

import { authRouteNames } from '@/ui/routes/routesNames/authRouteNames'

import ForgotPasswordProvider from '../modules/auth/contexts/ForgotPasswordContext'

const AuthLayout = lazy(() => import('@/ui/layouts/AuthLayout'))

const Login = lazy(() => import('@/ui/modules/auth/views/Login'))
const Access = lazy(() => import('@auth-ui/views/Access'))
const ForgotMyPassword = lazy(
  () => import('@/ui/modules/auth/views/ForgotPassword')
)
const InsertYourPin = lazy(() => import('@/ui/modules/auth/views/InsertPin'))
const ChangePassword = lazy(
  () => import('@/ui/modules/auth/views/ChangePassword')
)
const ChangePasswordSuccessful = lazy(
  () => import('@/ui/modules/auth/views/ChangePasswordSuccess')
)

const SelectRecover = lazy(
  () => import('@/ui/modules/auth/views/SelectRecover')
)

const ForgotMyLogin = lazy(() => import('@/ui/modules/auth/views/ForgotLogin'))
const RecoverLogin = lazy(() => import('@/ui/modules/auth/views/RecoverLogin'))
const InsertPinLogin = lazy(
  () => import('@/ui/modules/auth/views/InsertPinLogin')
)

export function AuthRoutes() {
  return (
    <>
      <Route path={authRouteNames.access} element={<Access />} />

      <Route element={<AuthLayout />}>
        <Route path={authRouteNames.home} element={<Login />} />
        <Route
          path={authRouteNames.changePasswordSuccessful}
          element={<ChangePasswordSuccessful />}
        />
        <Route
          path={authRouteNames.recoverLoginSuccesFul}
          element={
            <ForgotPasswordProvider>
              <RecoverLogin />
            </ForgotPasswordProvider>
          }
        />
        <Route
          path={authRouteNames.selectRecover}
          element={<SelectRecover />}
        />

        <Route
          element={
            <ForgotPasswordProvider>
              <Outlet />
            </ForgotPasswordProvider>
          }
        >
          <Route
            path={authRouteNames.forgotPassword}
            element={<ForgotMyPassword />}
          />
          <Route
            path={authRouteNames.forgotLogin}
            element={<ForgotMyLogin />}
          />
          <Route path={authRouteNames.insertPin} element={<InsertYourPin />} />
          <Route
            path={authRouteNames.insertPinLogin}
            element={<InsertPinLogin />}
          />
          <Route
            path={authRouteNames.changePassword}
            element={<ChangePassword />}
          />
        </Route>
      </Route>
    </>
  )
}
